// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"357ab7cb","526":"01f15234","787":"44c92f1d"}[chunkId] + ".chunk.js";
};